var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2974 6.95553H14.4556C14.2261 6.95553 14.0035 6.84507 13.8783 6.66317L12.8974 5.29236C12.7652 5.11045 12.5495 5 12.32 5H8.89041C8.66085 5 8.43827 5.11045 8.31305 5.29236L7.33216 6.66317C7.19998 6.84507 6.98432 6.95553 6.75476 6.95553H4.69565C4.31304 6.95553 4 7.24788 4 7.6052V17.3503C4 17.7076 4.31304 18 4.69565 18H19.3043C19.687 18 20 17.7076 20 17.3503V7.6052C20 7.24788 19.687 6.95553 19.3043 6.95553H19.2974ZM11.1609 15.0691C12.9536 15.0691 14.4069 13.6159 14.4069 11.8231C14.4069 10.0304 12.9536 8.57715 11.1609 8.57715C9.3682 8.57715 7.91492 10.0304 7.91492 11.8231C7.91492 13.6159 9.3682 15.0691 11.1609 15.0691ZM17.6529 9.22635C17.6529 9.58489 17.3622 9.87555 17.0037 9.87555C16.6451 9.87555 16.3545 9.58489 16.3545 9.22635C16.3545 8.8678 16.6451 8.57715 17.0037 8.57715C17.3622 8.57715 17.6529 8.8678 17.6529 9.22635Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidCamera);
export default __webpack_public_path__ + "static/media/solid-camera.6f4b64d551635207ad3ce63f1d65f59a.svg";
export { ForwardRef as ReactComponent };